import { isEmpty } from 'lodash';

export const OauthErrors = {
    GOOGLE_OAUTH_FAILED: {
        title: 'Trouble connecting',
        message: 'We couldn’t connect to your Google account. Please make sure you ‘Allow’ ECAL to access Google.',
    },

    // Calendar: Outlook.com (Web)
    WINDOWSLIVE_OAUTH_FAILED: {
        title: 'Trouble connecting',
        message: 'We couldn’t connect to your Outlook.com (Web) account. Please make sure you ‘Allow’ ECAL to access Outlook.com (Web).',
    },

    // Calendar: Office 365
    OFFICE365_OAUTH_FAILED: {
        title: 'Trouble connecting',
        message: 'We couldn’t connect to your Office 365 account. Please make sure you ‘Allow’ ECAL to access Office 365.',
    },

    DEFAULT_ERROR: {
        title: 'Oops!',
        message: 'Something went wrong. Our technical team are looking into the problem. Please try again later.',
    },
};

export function getoOauthErrorByKey (key) {
    if (!isEmpty(OauthErrors[key])) {
        return OauthErrors[key];
    }
    return OauthErrors.DEFAULT_ERROR;
}

export default OauthErrors;